module.exports = __webpack_public_path__ + "static/media/calendar-black.42fbea13.svg";